module.exports = __webpack_public_path__ + "static/img/common_about_clinic.ebcc720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common_about_clinic.png
// module id = N1Gh
// module chunks = 0